
import axios from 'axios';
import { FileWrapper } from 'app/shared/model/shared.model';
import { CaseRevisionModel, CaseRevisionsDataModel } from 'app/edozvola/cases/case-revision/model/case-revision.model';

export const saveCaseRevision = async (uuid: string, caseRevision: CaseRevisionModel): Promise<any> => {
  return await new Promise((resolve, reject) => {
    const formData = new FormData();
    formData.append('file', caseRevision.multipartFile);
    formData.append('dto', new Blob([JSON.stringify(caseRevision)], { type: 'application/json' })); // Attach JSON as a Blob

    axios
      .post(`api/case-revision/${uuid}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.response.data.detail);
      });
  });
};

export const getCaseRevision = async (idCaseRevision: string): Promise<CaseRevisionModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/case-revision/${idCaseRevision}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const fetchCaseRevisions = async ({ signal, pagination, uuid }): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(
        `api/case-revision/find-all/${uuid}??page=${pagination.page}&size=${pagination.size}&column=${pagination.column}&direction=${pagination.direction}`,
        {
          signal: signal,
        },
      )
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.error);
      });
  });
};

export const deleteCaseRevision = async (idCaseRevision: number): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .delete(`api/case-revision/${idCaseRevision}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const getCaseRevisionFile = async (idCaseRevision): Promise<FileWrapper> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/case-revision/${idCaseRevision}/preview-file`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const getCaseRevisionData = async (uuid: string): Promise<CaseRevisionsDataModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/case-revision/${uuid}/get-data`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.detail))
  })
}

export const saveCaseRevisionData = async (uuid: string, caseRevisionData: CaseRevisionsDataModel): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/case-revision/${uuid}/save-data`, caseRevisionData)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.detail))
  })
}
